import {Injectable} from '@angular/core';
import {ClickFinderState} from '../modules/akita-mimic/models/store-states/click-finder-state.model';
import {StoreService} from '../modules/akita-mimic/services/store.service';

@Injectable({ providedIn: 'root' })
export class ClickFinderStore extends StoreService<ClickFinderState> {
    public constructor() {
        super('click-finder', {
            isUsingSmartFilter: true,
            activeRootNode: undefined,
            vaultRootNodes: {},
            parentNodes: [],
            nodes: [],
            nodeDocuments: [],
            activeNode: undefined,
            loading: false
        });
    }
}
